//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import _ from 'underscore';

//style
import './XmlExports.scss';

//api
import { api } from '../../functions/api';

//custom components
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import CustomTable from '../../components/complex/customTable';
import DeleteDialog from '../../components/global/deleteDialog';
import AddEdit from './AddEdit/AddEditXmlExports'

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class XmlExports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: true,
            addEditDialog: false,
            idItem: 0,
        }
    }

    replicateItem = (item) => {
        const { id } = item
        api({
            method: 'put',
            url: `lists/xml-exports/${id}/replicate`,
            authorization: this.props.internal.user.access_token,
        }).then(response => {
            if (response.success) {
                this.props.internal.setSnackbar(response.data.message, true, false)
                this.props.internal.setActionEdit({
                    id: response.data.data.id,
                    edit: true,
                });
            }
        })
    }

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.LISTS_XML_EXPORTS);
        this.loadItems();
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    tableHeader = [
        {
            "title": "title",
            "numeric": false
        },
        {
            "title": "url",
            "numeric": false
        },
        {
            "title": "rabat_included",
            "numeric": false
        },
        {
            "title": "last_export_generated_at",
        },
    ];
    tableBody = [
        "title",
        "url",
        "xml_export_rabat",
        "last_export_generated_at",
    ]

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            action: "edit"
        },
        {
            title: this.props.translate.i18n.MODULES.XML_EXPORTS.MENU_ITEMS.REPLICATE,
            action: "replicate",
            callback: this.replicateItem
        },
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
        }
    ];

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadItems()
    }

    loadItems = _.debounce(async (size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {
        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {

            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
                this.setState({searchTerm: searchterm})
            }
        }

        let filters = {}
        let params = {}

        params.filters = filters
        params.searchterm = searchterm



        let load_data = await api({
            method:'get',
            url: 'lists/xml-exports',
            authorization: this.props.internal.user.access_token,
            params: params
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({loadingTable: false})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
    }, 500)

    handleOpenCloseDialog = (refresh = false) => {
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(refresh) {
            this.loadItems()
        }
    }

    handleDelete = async() => {
        let idItem = toJS(this.props.internal.actionDeleteObj.id)

        let delete_data = await api({
            method: "delete",
            url: `lists/xml-exports/${idItem}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadItems();
            this.props.internal.setActionDelete();
        }
    }

    changeItems = (idItem) => {
        this.setState({changeItems: !this.state.changeItems, idItem: idItem})
    }

    render () {
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'fixed-sets'}>
                    {/* dialog pre upravovanie/vytvorenie */}
                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEdit
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES['XML_EXPORTS'].CREATE_NEW_TITLE :this.props.translate.i18n.MODULES['XML_EXPORTS'].EDIT_TITLE}
                            shop_id={this.state.shop_id}
                        />
                    }
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES['XML_EXPORTS'].DELETE_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between mb-first-line'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.MODULES['XML_EXPORTS'].ADD_NEW}
                            onClick = {this.handleOpenCloseDialog}
                        >
                            <Icon path = {mdiPlus} size = {1}/>
                        </CustomButton>
                    </div>
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        // null
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/xml_exports'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openCloseDialogChangePosition}
                            clickOnProductionStatus={this.clickOnProductionStatus}
                            // handleChangeType={this.handleChangeType}
                            disablePagination={true}
                            disableSort
                            changeItems={this.changeItems}
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/XmlExports/XmlExports.jsx